/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Pxk_Scenting_Notes_EmptyInputs */

const vi_sl_pxk_scenting_notes_empty = /** @type {(inputs: Sl_Pxk_Scenting_Notes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có phiếu nhập kho lấy hương nào.`)
};

/**

* @param {Sl_Pxk_Scenting_Notes_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_pxk_scenting_notes_empty = /** @type {((inputs?: Sl_Pxk_Scenting_Notes_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Pxk_Scenting_Notes_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_pxk_scenting_notes_empty(inputs)
});